import clsx from 'clsx';
import {
  classifyStrength,
  type PasswordStrength,
} from '../lib/password';

const LABEL: Record<PasswordStrength, string> = {
  weak: '弱',
  fair: '一般',
  good: '良好',
  strong: '强',
  excellent: '极强',
};

const FILLED: Record<PasswordStrength, number> = {
  weak: 1,
  fair: 2,
  good: 3,
  strong: 4,
  excellent: 5,
};

const COLOR: Record<PasswordStrength, string> = {
  weak: 'bg-rose-500',
  fair: 'bg-amber-500',
  good: 'bg-yellow-500',
  strong: 'bg-emerald-500',
  excellent: 'bg-emerald-600',
};

/**
 * 5-segment strength bar. The strength is computed once from
 * (length, charsetSize) at the page level and passed to every row;
 * we don't recompute per-password because every row uses the same
 * params (the lib enforces uniform charset).
 */
export function PasswordStrengthBar({
  bits,
}: {
  bits: number;
}): JSX.Element {
  const strength = classifyStrength(bits);
  const filled = FILLED[strength];
  return (
    <div className="flex items-center gap-2 text-[11px]">
      <div className="flex h-1.5 gap-0.5" role="img" aria-label={`强度 ${LABEL[strength]}`}>
        {Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={clsx(
              'h-full w-6 rounded-sm transition',
              i < filled ? COLOR[strength] : 'bg-bg-soft border border-line/40',
            )}
          />
        ))}
      </div>
      <span className="text-ink-dim">
        {bits.toFixed(1)} bits · {LABEL[strength]}
      </span>
    </div>
  );
}
